import { render, staticRenderFns } from "./UploadTermsAndConditionPdfModal.vue?vue&type=template&id=51dde7de&scoped=true&"
import script from "./UploadTermsAndConditionPdfModal.vue?vue&type=script&lang=js&"
export * from "./UploadTermsAndConditionPdfModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dde7de",
  null
  
)

export default component.exports